<template>
    <div class="mt-11">
        <p
            class="text-3lg font-bold mb-4 text-center"
            v-if="getServiceType === 'iptvServices'">
            Need Stream TV Boxes for additional rooms?
        </p>
        <p
            class="text-3lg font-bold mb-4 text-center"
            v-if="getServiceType === 'tivoServices'">
            Connect Additional TVs
        </p>
        <div class="desktop:flex justify-between items-center">
            <div class="flex items-center gap-5 mb-4 desktop:mb-0">
                <img src="/assets/images/buyflow/TVPlus.webp" width="42" height="42" alt="TV Icon">
                <p v-if="getServiceType === 'iptvServices'">
                    Make sure each TV is ready to go with an additional Stream TV Box.
                </p>
                <p v-if="getServiceType === 'tivoServices'">
                    Make sure each TV is ready to go with an additional TiVo device.
                </p>
            </div>
            <div class="flex gap-6 justify-center desktop:justify-end">
                <PricePerMonth
                    :price="priceToShow"
                    :note="quantity > 0 ? null : priceNote"
                    :showPlus="false"
                />
                <button
                    v-if="ctaType === 'button'"
                    type="button"
                    class="buyflow-button text-sm"
                    :class="{
                        'active': ctaButtonIsSelected,
                        'compressed': ctaButtonMini,
                    }"
                    :disabled="ctaButtonIsDisabled"
                    @click="$emit('cta-button-clicked')">

                    <template v-if="ctaButtonIsSelected">
                        <IconCheck class="inline mr-1" />
                        {{ ctaButtonTextSelected }}
                    </template>
                    <template v-else>
                        {{ ctaButtonText }}
                    </template>

                </button>
                <div v-if="hasSelectedAService">
                    <div v-if="ctaType === 'dropdown'"
                        class="buyflow-numeric-select"
                        :class="{ 'active': quantity > 0 }">
                        <select @change="quantityChanged"
                                v-model="quantity"
                                class="edge">
                            <option v-for="(item, index) in new Array(ctaDropdownMax + 1)"
                                    :key="index"
                                    :value="index">
                                {{ index }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PricePerMonth from "@/atoms/PricePerMonth"
import IconCheck from "@/atoms/icons/IconCheck"

export default {
    name: 'AdditionalEquipment',
    components: {
        PricePerMonth,
        IconCheck,
    },
    props: {
        hasSelectedAService: {
            type: Boolean,
            default: false,
        },
        getServiceType: {
            type: String,
            required: true,
            validator: val => [
                'tivoServices',
                'iptvServices',
                'ultraServices',
            ].includes(val),
        },
        upgradeType: {
            type: String,
            required: true,
            default: null,
        },
        title: {
            type: String,
            required: true,
            default: null,
        },
        price: {
            type: Number,
            required: true,
            default: 0,
        },
        priceNote: {
            type: String,
            default: null,
        },
        ctaType: {
            type: String,
            required: true,
            default: 'button',
            validator: val => [
                'button',
                'dropdown',
            ].includes(val)
        },
        ctaButtonText: {
            type: String,
            default: 'Select',
        },
        ctaButtonTextSelected: {
            type: String,
            default: 'Selected',
        },
        ctaButtonMini: {
            type: Boolean,
            default: true,
        },
        ctaButtonIsSelected: {
            type: Boolean,
            default: false,
        },
        ctaButtonAllowDeselect: {
            type: Boolean,
            default: false,
        },
        ctaDropdownValue: {
            type: Number,
            default: 0,
        },
        ctaDropdownMax: {
            type: Number,
            default: 1,
        },
    },
    data: () => ({
        quantity: 0,
    }),
    computed: {
        priceToShow () {
            return this.quantity > 0 ? this.quantity * this.price : this.price
        },
        ctaButtonIsDisabled() {
            return this.ctaButtonIsSelected && !this.ctaButtonAllowDeselect
        },
    },
    mounted() {
        this.quantity = this.ctaDropdownValue
    },
    methods: {
        quantityChanged() {
            this.$emit('cta-dropdown-changed', this.quantity)
        },
    },
}
</script>

<style>

</style>
